<script setup>
import { useTheme } from "@/utils/composables/useTheme";
const { isDark, toggleTheme } = useTheme();

defineProps({
  variant: { type: String, default: "card" }, // "card" | "split"
});
</script>

<template>
  <div class="auth-layout" :class="{ 'auth-layout--split': variant === 'split' }">
    <button class="auth-theme-btn" @click="toggleTheme" :title="isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'">
      <i :class="isDark ? 'bi bi-sun-fill' : 'bi bi-moon-fill'"></i>
    </button>
    <slot />
  </div>
</template>

<style scoped>
.auth-layout {
  min-height: 100vh;
  width: 100%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  position: relative;
  transition: background 0.3s;
  box-sizing: border-box;
}

.auth-layout--split {
  padding: 0;
  align-items: stretch;
  justify-content: stretch;
}

.auth-theme-btn {
  position: fixed;
  top: 20px;
  right: 24px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #64748b;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  z-index: 10;
}

.auth-theme-btn:hover {
  background: #f8fafc;
  color: #1e3155;
  border-color: #9ca3af;
}

/* ── Dark mode ─────────────────────────────────────────────────────── */
[data-theme="dark"] .auth-layout {
  background: #0d1117;
}

[data-theme="dark"] .auth-theme-btn {
  background: #161c2c;
  border-color: #2d3f5a;
  color: #9aadc4;
}

[data-theme="dark"] .auth-theme-btn:hover {
  background: #1e2a3e;
  color: #e8edf5;
  border-color: #3d5070;
}
</style>
